import { Context } from "@/core/context";
import {
  DrawOperateState,
  IDrawOperation,
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
} from "../IDrawOperation";
import { DBEntity } from "@/core/DBEntity";
import { generateUUID } from "three/src/math/MathUtils";
import { DrawPointLayout } from "@/draws/DrawLayout/DrawPointLayout";
import { DrawLineLayout } from "@/draws/DrawLayout/DrawLineLayout";
import { DrawArcLayout } from "@/draws/DrawLayout/DrawArcLayout";
import { DbLayer } from "@/CadEngine";
import { DrawRectangleLayout } from "./DrawRectangleLayout";
import {
  LayoutType,
  DrawLayoutParams,
  FinishResultToArc,
  CommonColor,
} from "@/core/Parameters";
import { DrawFanShapedLayout } from "./DrawFanShapedLayout";
export class DrawLayout {
  private m_layer: DbLayer;
  private m_color: number;
  private layoutType: LayoutType;
  // private isPipeLink: boolean = true;
  private m_context: Context;
  private points: THREE.Vector3[] = [];
  public drawLayoutObject!:
    | DrawPointLayout
    | DrawLineLayout
    | DrawArcLayout
    | DrawRectangleLayout
    | DrawFanShapedLayout;
  private completeCallback!: any;
  private specialParams?: any;
  private m_callbackUnderway: (point: THREE.Vector3) => void;

  constructor(context: Context, DrawLayoutParams: DrawLayoutParams) {
    this.m_context = context;
    // let layer = this.m_context.ModelManager.GetLayerByName(
    //   DrawLayoutParams.layerName
    // );
    // if (!layer) {
    //   layer = new DbLayer(DrawLayoutParams.layerName, generateUUID());
    //   layer.Color = CommonColor.White;
    //   layer.ColorIndex = 1;
    //   layer.Objects = [];
    //   this.m_context.ModelManager.addLayer(layer);
    // }
    this.m_layer = DrawLayoutParams.layer;
    this.m_color = DrawLayoutParams.color;
    this.layoutType = DrawLayoutParams.layoutType;
    // if (DrawLayoutParams.isPipeLink) {
    //   this.isPipeLink = DrawLayoutParams.isPipeLink;
    // }
    this.completeCallback = DrawLayoutParams.completeCallback;
    this.m_callbackUnderway = DrawLayoutParams.callbackUnderway;
    this.specialParams = DrawLayoutParams.specialParams;

    this.checkDrawLayout();
  }
  private checkDrawLayout() {
    if (this.layoutType == LayoutType.PointLayout) {
      // if (this.isPipeLink) {
      this.drawLayoutObject = new DrawPointLayout(
        this.m_context,
        this.m_layer,
        this.m_color,
        this.specialParams
      );
      // }
    } else if (this.layoutType == LayoutType.LineLayout) {
      this.drawLayoutObject = new DrawLineLayout(
        this.m_context,
        this.m_layer,
        this.m_color,
        this.specialParams
      );
      if (!this.specialParams) {
        console.error("直线布置时相关参数不能为空！");
        setTimeout(() => {
          this.m_context.DrawManager.DrawFinish(1);
        }, 100);
        return;
      }
    } else if (this.layoutType == LayoutType.ArcLayout) {
      this.drawLayoutObject = new DrawArcLayout(
        this.m_context,
        this.m_layer,
        this.m_color,
        this.specialParams
      );
    } else if (this.layoutType == LayoutType.RectangleLayout) {
      this.drawLayoutObject = new DrawRectangleLayout(
        this.m_context,
        this.m_layer,
        this.m_color,
        this.specialParams
      );
      if (!this.specialParams) {
        console.error("矩形布置时相关参数不能为空！");
        setTimeout(() => {
          this.m_context.DrawManager.DrawFinish(1);
        }, 100);
        return;
      }
    } else if (this.layoutType == LayoutType.FanShapedLayout) {
      this.drawLayoutObject = new DrawFanShapedLayout(
        this.m_context,
        this.m_layer,
        this.m_color,
        this.specialParams
      );
    }
  }

  onMouseMove(e: PointerEvent): void {
    this.drawLayoutObject.onMouseMove(e);
  }
  onKeyDown(e: KeyboardEvent): void {
    // if (!this.isPipeLink) return;
    this.drawLayoutObject.onKeyDown(e);
    if (e.key == "Enter") {
      let points = this.drawLayoutObject.GetPoints();
      if (
        this.drawLayoutObject instanceof DrawLineLayout ||
        this.drawLayoutObject instanceof DrawRectangleLayout
      ) {
        if (points.length <= 2) {
          this.m_callbackUnderway(points[points.length - 1]);
        }
      } else if (this.drawLayoutObject instanceof DrawPointLayout) {
        this.m_callbackUnderway(points[points.length - 1]);
      }
    }
  }
  onKeyUp(e: KeyboardEvent): void {
    this.drawLayoutObject.onKeyUp(e);
  }
  OnZoom(camera: THREE.Camera) {}
  OnWheel(e: WheelEvent): void {
    this.drawLayoutObject.OnWheel(e);
  }
  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(params: DrawOperationMovePointParams): void {
    this.drawLayoutObject.OnMovePoint(params);
  }
  OnDownPoint(params: DrawOperationMovePointParams): void {
    this.drawLayoutObject.OnDownPoint(params);
    if (
      this.drawLayoutObject instanceof DrawLineLayout ||
      this.drawLayoutObject instanceof DrawRectangleLayout
    ) {
      if (this.drawLayoutObject.GetPoints().length <= 2) {
        this.m_callbackUnderway(params.point);
      }
    } else if (this.drawLayoutObject instanceof DrawPointLayout) {
      this.m_callbackUnderway(params.point);
    } else if (this.drawLayoutObject instanceof DrawArcLayout) {
      if (this.drawLayoutObject.GetPoints().length <= 3) {
        this.m_callbackUnderway(params.point);
      }
    } else if (this.drawLayoutObject instanceof DrawFanShapedLayout) {
      if (this.drawLayoutObject.GetPoints().length <= 4) {
        this.m_callbackUnderway(params.point);
      }
    }
  }
  GetPoints(): THREE.Vector3[] {
    return this.points;
  }
  SetDrawLineForDashed(): void {}

  Finish() {
    if (this.drawLayoutObject instanceof DrawPointLayout) {
      let drawResult = this.drawLayoutObject.Finish(DrawOperateState.complete);
      if (drawResult) {
        this.completeCallback(drawResult);
      }
    }
    if (this.drawLayoutObject instanceof DrawLineLayout) {
      let drawResult = this.drawLayoutObject.Finish(DrawOperateState.complete);
      if (drawResult) {
        this.completeCallback(drawResult);
      }
    }
    if (this.drawLayoutObject instanceof DrawArcLayout) {
      let drawResult = this.drawLayoutObject.Finish(DrawOperateState.complete);
      if (drawResult) {
        this.completeCallback(drawResult);
      }
    }
    if (this.drawLayoutObject instanceof DrawRectangleLayout) {
      let drawResult = this.drawLayoutObject.Finish(DrawOperateState.complete);
      if (drawResult) {
        this.completeCallback(drawResult);
      }
    }
    if (this.drawLayoutObject instanceof DrawFanShapedLayout) {
      let drawResult = this.drawLayoutObject.Finish(DrawOperateState.complete);
      if (drawResult) {
        this.completeCallback(drawResult);
      }
    }
    return undefined;
  }
}
